import {API_ENDPOINTS, LoadingKeys} from '@/constants';
import {IPaymentErrorItem, ListResponse} from '@/models';

import {AxiosRequestConfig} from 'axios';
import {create} from 'zustand';
import {handleApiCallInStore} from './utils';
import {http} from '@/utils';
import {persist} from 'zustand/middleware';

export interface IPaymentStore {
  paymentErrorList: IPaymentErrorItem[];
  getPaymentError: (params) => void;
  refundPayment: (id: string, status: string) => void;
  nbHits: number;
}

export const usePaymentStore = create(
  persist<IPaymentStore>(
    set => ({
      paymentErrorList: [],
      nbHits: 0,
      getPaymentError: async params => {
        handleApiCallInStore(LoadingKeys.paymentErrorList, async () => {
          const {data} = await http.get<ListResponse<IPaymentErrorItem>>(
            `${API_ENDPOINTS.payment}?status=pending`,
            {params} as AxiosRequestConfig
          );
          const {items = [], nbHits = 0} = data || {};
          set(() => ({paymentErrorList: items, nbHits}));
        });
      },
      refundPayment: (id, status) => {
        handleApiCallInStore(LoadingKeys.RefundPayment, async () => {
          await http.post(`${API_ENDPOINTS.payment}/${id}`, {
            status,
            id,
          });
          set(({paymentErrorList}) => ({
            paymentErrorList: paymentErrorList.filter(
              paymentErrorItem => paymentErrorItem.transactionId !== id
            ),
          }));
        });
      },
    }),
    {
      name: 'payment-storage',

    }
  )
);
